// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { NewsInfoResponseDTO } from "../../api/backend-openapi";
import { deleteNews, setNews, updateNews } from "./NewsEvents";

export const NewsStore = createStore<NewsInfoResponseDTO[]>([])
  .on<NewsInfoResponseDTO[]>(
    setNews,
    (state: NewsInfoResponseDTO[], payload: NewsInfoResponseDTO[]) => payload
  )
  .on<string>(deleteNews, (state: NewsInfoResponseDTO[], payload: string) =>
    state.filter(news => news.id !== payload)
  )
  .on<NewsInfoResponseDTO>(
    updateNews,
    (state: NewsInfoResponseDTO[], payload: NewsInfoResponseDTO) => [
      ...state.filter(news => news.id !== payload.id),
      payload
    ]
  );
